import { SxProps } from '@mui/material';

export const rootStyles: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  gap: '3.2rem',
};
export const scrollContainerStyles: SxProps = {
  height: '400px',
  overflowY: 'auto',
};
